import { render, staticRenderFns } from "./RimconfigMenu.vue?vue&type=template&id=5fc1d874"
import script from "./RimconfigMenu.vue?vue&type=script&lang=js"
export * from "./RimconfigMenu.vue?vue&type=script&lang=js"
import style0 from "./RimconfigMenu.vue?vue&type=style&index=0&id=5fc1d874&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports